/*!

=========================================================
* Argon Dashboard React - v1.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-react
* Copyright 2019 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';
import classnames from 'classnames';
// reactstrap components
// core components
import AdminNavbar from 'components/Navbars/AdminNavbar.js';
import Sidebar from 'components/Sidebar/Sidebar.js';

import routes from 'routes.js';
import io from 'socket.io-client';
import cred from '../util/cred';
import { axiosGet } from '../util/apiConfig';

class Admin extends React.Component {
  state = {
    whatsappUnreadCount: 0,
    sidebarOpen: false, // Collapsed by default!
  };

  toggleSidebar = () => {
    this.setState({ sidebarOpen: !this.state.sidebarOpen });
  };

  closeSidebar = () => {
    this.setState({ sidebarOpen: false });
  };

  handleDocumentClick = (e) => {
    if (!this.state.sidebarOpen) return;
    const sidebar = document.getElementById('sidenav-main');
    const isHamburger = e.target.closest('.hamburger-btn');
    if (sidebar && !sidebar.contains(e.target) && !isHamburger) {
      this.closeSidebar();
    }
  };

  fetchUnreadCount = () => {
    axiosGet('message/whatsapp/unread-count')
      .then((res) => {
        if (!res.isError && res.data) {
          this.setState({ whatsappUnreadCount: res.data.count || 0 });
        }
      })
      .catch((err) => {
        console.error('Error fetching unread count:', err);
      });
  };

  playWhatsappSound = () => {
    try {
      const audio = new Audio("https://assets.mixkit.co/active_storage/sfx/2869/2869-84.wav");
      audio.play().catch((e) => console.log('Audio playback blocked/failed:', e));
    } catch (err) {
      console.error('Audio initialization failed:', err);
    }
  };

  componentDidMount() {
    let storage = localStorage.getItem('Sanga_Admin');
    storage = storage ? JSON.parse(storage) : null;

    if (storage) {
      // Fetch initial count
      this.fetchUnreadCount();

      // Establish Socket.io connection dynamically
      const socketUrl = cred.API_PATH.split('/api/v1/')[0] || 'http://localhost:4000';
      this.socket = io(socketUrl, { transports: ['websocket'] });

      this.socket.on('whatsapp_message', (message) => {
        if (message.direction === 'inbound') {
          // Play the distinct alert sound!
          this.playWhatsappSound();
          // Refetch/increment unread count
          this.fetchUnreadCount();
        }
      });

      this.socket.on('whatsapp_status', () => {
        this.fetchUnreadCount();
      });
    } else {
      this.props.history.push({
        pathname: '/auth',
        state: {},
      });
    }
    document.addEventListener('click', this.handleDocumentClick);
  }

  componentWillUnmount() {
    if (this.socket) {
      this.socket.disconnect();
    }
    document.removeEventListener('click', this.handleDocumentClick);
  }

  componentDidUpdate(prevProps) {
    if (this.props.location.pathname !== prevProps.location.pathname) {
      document.documentElement.scrollTop = 0;
      document.scrollingElement.scrollTop = 0;
      if (this.refs.mainContent) {
        this.refs.mainContent.scrollTop = 0;
      }
      this.fetchUnreadCount();
    }
  }

  getRoutes = (routes, userRole) => {
    return routes.map((prop, key) => {
      if (prop.layout === '/admin' && prop.roles.includes(userRole)) {
        return (
            <Route
                path={prop.layout + prop.path}
                render={(props) => (
                  <prop.component
                    {...props}
                    fetchUnreadCount={this.fetchUnreadCount}
                  />
                )}
                key={key}
            />
        );
      } else {
        return null;
      }
    });
  };

  getBrandText = (path) => {
    for (let i = 0; i < routes.length; i++) {
      if (
        this.props.location.pathname.indexOf(
          routes[i].layout + routes[i].path
        ) !== -1
      ) {
        return routes[i].name;
      }
    }
    return 'Brand';
  };

  render() {
    const userRole = localStorage.getItem('userRole');
    const { sidebarOpen } = this.state;
    return (
      <div className={classnames({ 'sidebar-expanded': sidebarOpen })}>
        <style>{`
          /* Collapsible vertical sidebar styles */
          #sidenav-main {
            transform: translateX(-100%) !important;
            transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
            z-index: 999999 !important;
            box-shadow: none !important;
          }
          
          .main-content {
            margin-left: 0 !important;
            transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
          }

          /* Expanded state */
          .sidebar-expanded #sidenav-main {
            transform: translateX(0) !important;
            box-shadow: 0 15px 35px rgba(50, 50, 93, 0.1), 0 5px 15px rgba(0, 0, 0, 0.08) !important;
          }
          /* Ensure sidebar has backdrop scroll prevention when expanded on mobile */
          @media (max-width: 991.98px) {
            .sidebar-expanded {
              overflow: hidden;
            }
            #sidenav-main {
              position: fixed !important;
              top: 0 !important;
              bottom: 0 !important;
              height: 100vh !important;
              width: 260px !important;
              max-width: 260px !important;
              left: 0 !important;
              overflow-y: auto !important;
              -webkit-overflow-scrolling: touch !important;
            }
          }

        `}</style>
        



        <Sidebar
          {...this.props}
          routes={routes.filter(route => route.roles.includes(userRole))}
          unreadCount={this.state.whatsappUnreadCount}
          closeSidebar={this.closeSidebar}
          // logo={{
          //   innerLink: '/admin/index',
          //   imgSrc: require('assets/img/brand/argon-react.png'),
          //   imgAlt: '...',
          // }}
        />
        <div className='main-content' ref='mainContent'>
          <AdminNavbar
            {...this.props}
            brandText={this.getBrandText(this.props.location.pathname)}
            toggleSidebar={this.toggleSidebar}
          />
          <Switch>
            {this.getRoutes(routes, userRole)}
            userRole === 'admin' ? (
            <Redirect from='*' to='/admin/listing' />
            ) : userRole === 'sub_admin' ? (
            <Redirect from='*' to='/admin/listing' />
            ) : userRole === 'sales_ops' ? (
            <Redirect from='*' to='/admin/listing' />
            ): userRole === 'sales' ?  (
            <Redirect from='*' to='/admin/sales-notification' />
            ) : userRole === 'support' ? (
            <Redirect from='*' to='/admin/message' />
            ): userRole === 'sales_support' ? (
            <Redirect from='*' to='/admin/message' />
            ): userRole === 'sales_admin' ? (
            <Redirect from='*' to='/admin/sales-followup' />
            ): (
            <Redirect from='*' to='/auth' />
            )
          </Switch>
        </div>
      </div>
    );
  }
}

export default Admin;
